import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

class ModalHardConfirm extends Component {
  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onClose} aria-labelledby="contained-modal-title-lg" bsSize='large' dialogClassName="modal-danger">
        <div className="modal-content" role="document">
          <div className="modal-header bg-danger text-white">
            <button type="button" className="close" onClick={this.props.onClose}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
            <h4 id="contained-modal-title" className="modal-title">{this.props.title}</h4>
          </div>
          <div className="modal-body">
            <div className="alert alert-danger">
              <i className="fa fa-exclamation-triangle"></i> <b>ATENÇÃO!</b> Esta ação não poderá ser desfeita!
            </div>
            <p>{this.props.mainMessage}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={this.props.onConfirm}>{this.props.confirmMessage}</button>
            <button type="button" className="btn btn-danger" onClick={this.props.onClose}>Cancelar</button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ModalHardConfirm;


// WEBPACK FOOTER //
// ./src/Components/Miscelania/ModalHardConfirm.js